export const SET_TRANSFER = "SET_TRANSFER";
export const SET_TRANSFER_SUCCESS = "SET_TRANSFER_SUCCESS";
export const SET_TRANSFER_FAILED = "SET_TRANSFER_FAILED";
export const SET_TRANSFER_DUPLICATED = "SET_TRANSFER_DUPLICATED";
export const RESET_TRANSFER_ERROR = "RESET_TRANSFER_ERROR";
export const SET_TRANSACTION_TIMEOUT = "SET_TRANSACTION_TIMEOUT";
export const SET_FNZ_TIMEOUT = "SET_FNZ_TIMEOUT";
export const SET_RESOURCE = "SET_RESOURCE";
export const TRANSACTION_TIMEOUT = "TRANSACTION_TIMEOUT";
export const FNZ_TIMEOUT = "FNZ_TIMEOUT";
export const RESET_DUPLICATE_TRANSACTION = "RESET_DUPLICATE_TRANSACTION";
